import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialog,
  MatDialogModule,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ThredBulletPointsData {
  title?: string;
  messages?: string[];
}

@Component({
  selector: 'thred-bullet-points-info-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule],
  templateUrl: './bullet-points-info-dialog.component.html',
  styleUrls: ['./bullet-points-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [MatDialog],
})
export class BulletPointsInfoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ThredBulletPointsData) {}
}
